<template>
  <div class="container">
    <!-- header -->
    <mt-header fixed class="header" :title="catTitle">
      <header-item slot="left" v-bind:isBack=true v-on:onclick="goBack()">
      </header-item>    
    </mt-header>
    <!-- body -->
    <div class="list-body">
      <!-- category list -->
      <articlelist-item v-for="(item, index) in catData" :key="index" v-on:onclick="getArticleInfo(item)"
        class="section-footer" 
        :icon="item.more?require('../../assets/image/change-icon/e9_folder.jpeg'):require('../../assets/image/change-icon/e9_doc.png')" 
        :title="item.title"
        :url="item.url">
      </articlelist-item>
      <!-- article list -->
      <articlelist-item v-for="(item, index) in articleData" :key="index" v-on:onclick="getArticleInfo(item)"
        class="section-footer" 
        :icon="item.more?require('../../assets/image/change-icon/e9_folder.jpeg'):require('../../assets/image/change-icon/e9_doc.png')" 
        :title="item.title"
        :url="item.url">
      </articlelist-item>
    </div>
  </div>  
</template>

<script>
import { HeaderItem } from '../../components/common'
import { Header } from 'mint-ui'
import ArticlelistItem from '../article/child/ArticlelistItem';
import { articleList,cateArticleList,catArticleAllList } from '../../api/article'; //文章列表
export default { 
  data() {
    return {
      catData:[],
      articleData:[],
      catTitle:'',
      cateId:null,
      aggrementUrl: '', 
    }
  },
  components: {
    ArticlelistItem
  }, 
  created(){
    this.cateId = this.$route.query.id;
/*    if(this.cateId){
      this.getArticleList()
    }else{
       this.cateArticleList();
    }*/
    if(this.cateId){
      this.catArticleAllList();
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1) 
    },
    // 获取分类接口
    cateArticleList() {
      cateArticleList(0, 1, 10).then( res => {
        if(res) {
          this.catData = res.articles;
          this.catTitle = res.cat_title;
        }
      })
    },
    // 获取文章列表数据
    getArticleList() {
      articleList(this.cateId, 1, 10).then( res => {
        if(res) {
          this.articleData = res.articles;
          this.catTitle = res.cat_title;
        }
      })
    },
    // 获取分类及文章接口
    catArticleAllList() {
      catArticleAllList(this.cateId, 1, 10).then( res => {
        if(res) {
          this.catData = res.category;
          this.articleData = res.articles;
          this.catTitle = res.cat_title;
        }
      })
    },
    getArticleInfo(item) {
      if(item.url){
        this.$router.push({ name: 'webPage', query: {'url': item.url,'title': item.title}})
      }else{
        this.$router.push('ArticleCat?id='+item.id);
        // this.$router.push({ name: 'help', query: {'cateId': item.id }})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    .header {
      @include header;
      background-color: #ed8b19;
      border-bottom:1px solid #E8EAED;
    }
    .list-body {
      margin-top: 44px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/page/article/ArticleCat.vue